import type { LinkedImage } from '@ps/web-martech-cms-types';
import { useResolver } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { CMSImage, CMSLink } from '@swf/cms';

import useAuthenticatedContent from '../../hooks/useAuthenticatedContent';

import styles from './CMSLinkedImage.scss';

const CMSLinkedImage: React.FC<LinkedImage & Partial<ClassNameProp>> = ({
  animated,
  className = '',
  logged_in_linked_image: loggedInLinkedImage,
  ...linkedImage
}) => {
  const { link, image } = useAuthenticatedContent(linkedImage, loggedInLinkedImage);
  let url = useResolver(link?.resolver_tag);
  if (!link.resolver_tag) {
    url = link.url || '';
  }

  return (
    <CMSLink
      {...link}
      url={url}
      logged_in_link={loggedInLinkedImage?.link}
      className={classNames(styles.image, className)}
    >
      <CMSImage
        {...image}
        logged_in_image={loggedInLinkedImage?.image}
        className={classNames(className, { [styles.animateOnHover]: animated })}
      />
    </CMSLink>
  );
};

export default CMSLinkedImage;
